<template>
    <div class="custom-form">
        <el-form ref="dynamicValidateForm" :model="formData" :inline="true" label-width="120px">
            <div class="col" v-for="(domain, index) in formData.domains" :key="index" v-show="!domain.hidden"
                :class="{'col-6': domain.span == 6, 'col-8': domain.span == 8, 'col-12': domain.span == 12 || !domain.span, 'col-18': domain.span == 18, 'col-24': domain.span == 24}">
                <el-form-item :label="domain.label" :prop="'domains.' + index + '.value'" :rules="domain.required ? {
                  required: true, message: domain.label + '不能为空', trigger: 'blur'
                } : null">
                    <el-cascader v-if="domain.type == 'cascader'" :show-all-levels="false" style="width: 100%;"
                        :props="{ checkStrictly: true }" v-model="domain.value" :options="domain.opt"></el-cascader>
                    <el-switch v-if="domain.type== 'switch'" v-model="domain.value" active-color="#13ce66"
                        inactive-color="#c1b9b9">
                    </el-switch>
                    <el-select style="width: 100%;" v-if="domain.type== 'select'" v-model="domain.value"
                        :placeholder="'请选择' + domain.label">
                        <el-option v-for="(opt, _opt) in domain.opt" :key="_opt" :label="opt.label" :value="opt.value">
                        </el-option>
                    </el-select>
                    <el-select style="width: 100%;" v-if="domain.type == 'inputSelect'" v-model="domain.value" filterable allow-create default-first-option clearable :placeholder="'请选择' + domain.label">
                        <el-option v-for="(opt, _opt) in domain.opt" :key="_opt" :label="opt.label"
                            :value="opt.value" :disabled="opt.disabled">
                        </el-option>
                    </el-select>
                    <el-input v-if="domain.type == 'password'" show-password v-model="domain.value"
                        :disabled="domain.disabled" type="password" :placeholder="'请输入' + domain.label"></el-input>
                    <el-input v-if="domain.type == 'input'" v-model="domain.value" :disabled="domain.disabled"
                        :placeholder="'请输入' + domain.label"></el-input>
                    <el-input v-if="domain.type == 'textarea'" type="textarea" v-model="domain.value"
                        :disabled="domain.disabled" :placeholder="'请输入' + domain.label"></el-input>
                    <el-input-number v-if="domain.type == 'number'" v-model="domain.value" :disabled="domain.disabled"
                        style="width: 100%;" :min="0" :placeholder="'请输入' + domain.label"></el-input-number>
                    <el-date-picker v-if="domain.type == 'date'" v-model="domain.value" :disabled="domain.disabled"
                        value-format="yyyy-MM-dd" style="width: 100%;" type="date" :placeholder="'请输入' + domain.label">
                    </el-date-picker>
                    <CusstomEditor v-if="domain.type== 'editor'" :data="domain.value" v-model="domain.value" :height="domain.height"
                        @handelChange="parmas => handelChange(domain, parmas)" />
                    <CustomUpload v-if="domain.type == 'upload'" editable :data="domain.value" :limit="domain.limit"
                        @handelChange="parmas => handelChange(domain, parmas)" />
                    <CustomTags v-if="domain.type == 'tag'" editable :data="domain.value"
                        @handelChange="parmas => handelChange(domain, parmas)" />
                </el-form-item>
            </div>
        </el-form>
        <div class="btns" v-if="formData.domains.length && !hideBtn">
            <el-button type="primary" @click="confirm">确认</el-button>
            <el-button @click="cancel">取消</el-button>
        </div>
        <el-empty v-if="!data.length" description="请点击新增或选中要编辑的栏目"></el-empty>
    </div>
</template>
<script>
import CustomUpload from "@/components/custom/CustomUpload.vue"
import CustomTags from "@/components/custom/CustomTags.vue"
import CusstomEditor from "@/components/custom/CusstomEditor.vue"
export default {
    components: { CustomUpload, CustomTags, CusstomEditor },
    data() {
        return {
            formData: {
                domains: []
            }
        }
    },
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        hideBtn: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        "data": function (val) {
            this.$refs.dynamicValidateForm.resetFields();
            this.formData.domains = JSON.parse(JSON.stringify(val))
        }
    },
    created() {
        this.formData.domains = JSON.parse(JSON.stringify(this.data))
    },
    methods: {
        // 子组件数据回填
        handelChange(item, val) {
            this.formData.domains = this.formData.domains.map(el => {
                return Object.assign(el, { value: el.prop == item.prop ? val : el.value })
            })
        },
        cancel() {
            this.$emit("change", false)
        },
        confirm() {
            this.$refs.dynamicValidateForm.validate((valid) => {
                if (valid) {
                    let params = {}
                    this.formData.domains.forEach(el => {
                        params[el.prop] = el.value
                    })
                    this.$emit("change", params)
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-form {
    background: #fff;
    border-radius: 5px;

    .el-form {
        padding: 20px;
        overflow: hidden;
    }

    .el-form-item {
        margin: 0;
    }


    .btns {
        border-top: 1px solid #dedede;
        text-align: right;
        padding: 10px;
    }

    /deep/.el-form--inline .el-form-item__content {
        width: calc(100% - 120px);
    }

    .el-form-item {
        width: 100%;
        margin-bottom: 20px;
    }
}
</style>